var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React from "react";
import { Row, Col } from "@folio/stripes/components";
import { Controller, useFormContext } from "react-hook-form";
import { RecekSelection } from "../inputs";
import { getIdError } from "../../utils/getFormErrors";
var TitleOwnerForm = function (_a) {
    var ownerOptions = _a.ownerOptions, onOwnerFilter = _a.onOwnerFilter, onOwnerChange = _a.onOwnerChange, _b = _a.disabled, disabled = _b === void 0 ? false : _b;
    var _c = useFormContext(), control = _c.control, errors = _c.formState.errors;
    return (React.createElement(Row, null,
        React.createElement(Col, { xs: 12 },
            React.createElement(Controller, { name: "owner", control: control, render: function (_a) {
                    var _b, _c;
                    var field = _a.field;
                    return (React.createElement(RecekSelection, __assign({}, field, { labelId: "ui-br-agency.title.form.section.owner", dataOptions: ownerOptions, asyncFilter: true, onFilter: onOwnerFilter, value: (_c = (_b = field.value) === null || _b === void 0 ? void 0 : _b.id) !== null && _c !== void 0 ? _c : "", onChange: onOwnerChange, error: getIdError(errors, "owner"), required: true, disabled: disabled })));
                } }))));
};
export default TitleOwnerForm;
